import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=1fab1279&scoped=true&functional=true"
var script = {}
import style0 from "./Step3.vue?vue&type=style&index=0&id=1fab1279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1fab1279",
  null
  
)

export default component.exports